import React from 'react';
import InputField from 'Components/InputField/InputField';

const PasswordRepeatField = () => {
  return (
    <InputField placeholder='Repeat Password' />
  )
}

export default PasswordRepeatField;